module.exports = __webpack_public_path__ + "static/media/img6.39252768.jpg";